import React from 'react';
import { AiOutlineDownload } from "react-icons/ai";
import "./ActivitiesAndProjects.css";

const StudentLessonMaterials = ({ materials, textColor, backgroundColor, iconBackground }) => {
  const handleDownload = async (material) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/public/Teacher_Lesson_Material/${material.url}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = material?.description || material.url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      // Fallback to direct link if fetch fails
      window.open(`${process.env.REACT_APP_LOCAL_SERVER_API}/public/Teacher_Lesson_Material/${material.url}`, '_blank');
    }
  };

  if (!materials || materials.length === 0) {
    return null;
  }

  return (
    <div className="AP_container">
      <div style={{
        display: "flex",
        alignItems: "center",
        padding: "10px",
        backgroundColor: backgroundColor,
        borderRadius: "25px",
        marginBottom: "20px",
        flexDirection: "column",
        gap: "10px",
        width: "40%",
        border: "1px solid #eee",
        borderRadius: "25px",
        padding: "10px"
      }}>
        {/* <div style={{ 
          width: "60px", 
          height: "60px", 
          borderRadius: "50%", 
          backgroundColor: iconBackground,
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center",
          marginRight: "20px"
        }}>
          <AiOutlineDownload size={30} color={textColor} />
        </div> */}
        <div style={{ width: "100%" }}>
          <h4 style={{ color: textColor, margin: "10px 0 5px 0", textAlign: "center" }}>Lesson Materials</h4>

        </div>

        <div style={{ padding: "0 20px 20px 20px", width: "100%" }}>
          {materials.map((material, index) => (
            <>
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  padding: "15px",
                  // border: "1px solid #eee",
                  // borderRadius: "8px",
                  marginBottom: "10px",
                  // backgroundColor: "#fff",
                  flexDirection: "column",
                }}
              >
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: "500", color: textColor, marginBottom: "5px",fontSize:"18px" }}>
                    {material.description}
                  </div>
                  <div style={{ fontSize: "16px", color: "#666" }}>
                    Lesson: {material.lessonName} 
                    {/* Uploaded by: {material.firstname} {material.lastname} | 
                Date: {new Date(material.date).toLocaleDateString()} */}
                  </div>
                </div>
                <button
                  onClick={() => handleDownload(material)}
                  style={{
                    backgroundColor: textColor,
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    padding: "8px 15px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px"
                  }}
                >
                  <AiOutlineDownload size={16} />
                  {/* Download */}
                </button>
              </div>
              <hr />
            </>
          ))}
        </div>
        <div></div>

      </div>


    </div>
  );
};

export default StudentLessonMaterials; 